import { render, staticRenderFns } from "./NoDetailsBox.vue?vue&type=template&id=458e05ee&scoped=true&"
import script from "./NoDetailsBox.vue?vue&type=script&lang=js&"
export * from "./NoDetailsBox.vue?vue&type=script&lang=js&"
import style0 from "./NoDetailsBox.vue?vue&type=style&index=0&id=458e05ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e05ee",
  null
  
)

export default component.exports